import React from "react";
import InfoIcon from "@material-ui/icons/InfoOutlined";

export const ExlyNote = ({
  icon,
  label,
  subLabel,
  className = "tw-bg-[#fff4ca]",
  subLabelClasName,
}) => {
  return (
    <div
      className={`tw-flex tw-items-center tw-gap-2 tw-mt-3 tw-text-xs tw-leading-4 tw-rounded-lg tw-p-[10px_8px] ${className}`}
    >
      {icon || <InfoIcon className="tw-text-[18px]" />}
      <div>
        {label}
        {subLabel && (
          <p className={`tw-ml-[18px] tw-text-xs ${subLabelClasName}`}>
            {subLabel}
          </p>
        )}
      </div>
    </div>
  );
};
